<template>
  <page>
    <template slot="content">
    <help-content :title="'WeBand3SCの取り扱い注意事項'">
      <template slot="content">
        <div class="text">
          ・新品開封後は必ず本体を<b>3時間以上充電</b>して、<b>ファームウェアのアップデート</b>を実施してからご利用ください。<br>
          　※手順：充電後→WeRUNアプリの「ホーム＞WeBand」でペアリング→ホーム画面に切り替える→自動アップデートのダイアログが表示されれば、終了するまでアプリを閉じないでください。<br><br>
          ・充電時に本体を<b>リストバンドから外さず</b>、そのまま充電器に挟んでください。<br>
          　※外した本体をリストバンドに取り付ける時に、本体周辺の溝にリストバンドをしっかり嵌め込んでいることをご確認ください。<br><br>
          ・接続QRコードが表示されない場合、<router-link class="help-detail-link" :to="{ name: 'Help31'}">WeBand3SCのリセット</router-link>の説明に従って本体をリセットしてください。<br><br>
          ・ライトピンク色のリストバンドは、衣服や生活環境により色移りされる場合があります。<br><br>
          ・各種お問い合わせは、WeRUNヘルプデスク（LineID：werunclub／Mail:help@werunclub.net）までご連絡ください。<br><br>
          ・LINE公式アカウントでは<b>使い方の動画（YouTube）</b>やお得な情報を配信中！LINE ID「@373ryedo」またはこちら↓のQRコードで友だち追加してください。
        </div>
        <img class="picture" src="../assets/images/q_and_a/H33.png">
      </template>
    </help-content>
    </template>
  </page>
</template>

<script>
  import HelpContent from '@/components/HelpContent'
  import Page from '@/components/Page'

  export default {
    components: {
      HelpContent,
      Page
    },
    mounted () {
      window.scrollTo(0, 0)
    }
  }
</script>

<style lang="scss" scoped>
  @import "../assets/style/settings.scss";
</style>



// WEBPACK FOOTER //
// src/pages/Help33.vue